var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgReasonMobileBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "294px",
    height: "82px",
    viewBox: "0 0 294 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Starry-C---2-Col",
    transform: "translate(0.000000, -1342.000000)",
    fill: "#FFFFFF",
    stroke: "#FFDD75",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 1342.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-474,157.086816 C-422.24941,206.33389 -380.971246,223.659668 -350.165507,209.064147 C-303.956898,187.170867 -287.207009,95.2774421 -176.279498,105.507786 C-65.3519861,115.73813 -23.2778188,264.001176 72.2591708,278.67291 C201.471751,310.88248 312.772235,157.944849 359,-3",
    id: "Path",
    transform: "translate(-57.500000, 140.000000) scale(-1, 1) rotate(-330.000000) translate(57.500000, -140.000000) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReasonMobileBg);
export default __webpack_public_path__ + "static/media/reason-mobile-bg.819c2cceb8e91e445cb122c77e240f9e.svg";
export { ForwardRef as ReactComponent };